import React from 'react';
import { BoardMotif } from './BoardMotif';
type Tome = {
  number: string;
  title: string;
  promise: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Here & Now',
  promise: 'Open, follow the figure, grade, offer and close any experiment — the base of the whole library.',
  badge: 'bg-sage',
  contents: ['The Figure-to-Experiment Map and the Grade Dial', 'The Three-Zone Check: where the client’s attention lives', '40 here-and-now questions sorted by intensity', '“This feels silly”: 12 responses that keep curiosity alive', '19 Experiment Cards + 5 worksheets']
}, {
  number: '02',
  title: 'Contact',
  promise: 'Introjection, projection, retroflection, deflection, confluence — and the relationship itself as the experiment.',
  badge: 'bg-teal-deep',
  contents: ['The Contact Interruption Compass: seven interruptions at a glance', 'The Cycle of Experience Map: see where the energy stalls', 'Undoing the Retroflection, without catharsis', 'Lines to name and repair a missed moment', '21 Experiment Cards + 5 worksheets']
}, {
  number: '03',
  title: 'Body, Voice & Language',
  promise: 'Embodied, movement, voice and language experiments you can offer in any room.',
  badge: 'bg-terra-deep',
  contents: ['The Embodied Figure Scan: four channels to watch', 'Exaggerate the Gesture · Same Sentence, Three Volumes', 'The Language Responsibility Shift: it → I, can’t → won’t, but → and', 'A no-touch policy and pacing for clients far from sensation', '25 Experiment Cards + 4 worksheets']
}, {
  number: '04',
  title: 'Chair Work & Dialogue',
  promise: 'Empty-chair, two-chair and polarity work, step by step — graded, paced and closed safely.',
  badge: 'bg-ochre-deep',
  contents: ['The Chair Work Grade Ladder: five rungs, from “about” to “switch”', 'The Polarity Bridge: from split to dialogue to integration', '30 facilitator lines for stuck moments', 'When the client freezes, loops or turns to you instead of the chair', '17 Experiment Cards + 5 worksheets']
}, {
  number: '05',
  title: 'Dreams, Fantasy & Creative Media',
  promise: 'Dream work, guided fantasy, art and metaphor — inviting the client to own the image, never decoding it.',
  badge: 'bg-sage-mid',
  contents: ['The Dream Ownership Sequence: tell, present tense, become, dialogue, own', 'The Create-Describe-Become Loop', 'Guided fantasies, each with a clear way back and grounding', 'A creative-media kit for a small office', '25 Experiment Cards + 4 worksheets']
}, {
  number: '06',
  title: 'Group Gestalt',
  promise: 'Experiments and session plans for therapy groups and training groups.',
  badge: 'bg-ink',
  contents: ['The Group Field Read: individual, interpersonal, whole group', 'The Witness Ladder and the Hot Seat, graded and always voluntary', 'Triads and fishbowl demos for training groups', '90- and 120-minute group session formulas', '22 Experiment Cards + 6 worksheets']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-cream" data-id="element-325" data-mp="1akymq421lzoe">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-326" data-mp="dwishunzn24y">
        <div className="text-center" data-id="element-327" data-mp="du634wfwhphv">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-328" data-mp="iuan4wg0p2cu">
            The complete library
          </p>
          <h2 id="tomes-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-329" data-mp="mve1feif2qby">
            Inside the library — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-330" data-mp="3r8t09cktf83b">
            They follow the arc of Gestalt work: awareness, contact, body,
            chairs, dreams and the group. Each volume stands on its own, with
            session formulas for 30, 50 and 80 minutes, a safety page and a
            printable field card.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-331" data-mp="3lyqiitdduc7v">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-2xl border border-sand-dark bg-white shadow-card" data-id="element-332" data-mp="3h66xjbcd8et1">
              <div className={`relative overflow-hidden ${tome.badge}`} data-id="element-333" data-mp="3q024mox1sfbb">
                <BoardMotif className="pointer-events-none absolute -right-5 -top-6 h-24 w-24 text-white/20" data-id="element-334" data-mp="8qvkoe710jtx" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-335" data-mp="3rizryzptmtz">
                  <span className="text-xs font-bold uppercase tracking-[2px] text-white/90" data-id="element-336" data-mp="2ai8kiou501j4">
                    Volume {tome.number}
                  </span>
                  <span className="font-display text-3xl leading-none text-white" data-id="element-337" data-mp="25l9t4e1uy8om">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-6 pt-5" data-id="element-338" data-mp="pzy434010pl4">
                <h3 className="font-display text-xl leading-snug text-sage" data-id="element-339" data-mp="bc3cxs1o2ta5">
                  {tome.title}
                </h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-340" data-mp="g9d7tn7trx5d">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-sand-dark pt-4" data-id="element-341" data-mp="2anb48ox3zhj">
                  {tome.contents.map((item, i) => <li key={item} className={`flex gap-2.5 text-[13px] ${i === tome.contents.length - 1 ? 'font-bold text-sage' : 'text-ink'}`} data-id="element-342" data-mp="6e1pkux7k7sv" data-mpi={i}>
                      <span className="mt-[5px] h-2 w-2 flex-none rounded-full border-2 border-terra" data-id="element-343" data-mp="1monmqwjh9m85" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}